var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTelegram = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 240.1 240.1"
}, props), /*#__PURE__*/React.createElement("linearGradient", {
  id: "telegram_svg__a",
  x1: -838.041,
  x2: -838.041,
  y1: 660.581,
  y2: 660.343,
  gradientTransform: "matrix(1000 0 0 -1000 838161 660581)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#2aabee"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#229ed9"
  }
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 120.1,
  cy: 120.1,
  r: 120.1,
  fill: "url(#telegram_svg__a)",
  fillRule: "evenodd",
  clipRule: "evenodd"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M54.3 118.8c35-15.2 58.3-25.3 70-30.2 33.3-13.9 40.3-16.3 44.8-16.4 1 0 3.2.2 4.7 1.4 1.2 1 1.5 2.3 1.7 3.3s.4 3.1.2 4.7c-1.8 19-9.6 65.1-13.6 86.3-1.7 9-5 12-8.2 12.3-7 .6-12.3-4.6-19-9-10.6-6.9-16.5-11.2-26.8-18-11.9-7.8-4.2-12.1 2.6-19.1 1.8-1.8 32.5-29.8 33.1-32.3.1-.3.1-1.5-.6-2.1s-1.7-.4-2.5-.2c-1.1.2-17.9 11.4-50.6 33.5-4.8 3.3-9.1 4.9-13 4.8-4.3-.1-12.5-2.4-18.7-4.4-7.5-2.4-13.5-3.7-13-7.9.3-2.2 3.3-4.4 8.9-6.7",
  clipRule: "evenodd"
})));
export { SvgTelegram as ReactComponent };
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIj8+DQo8c3ZnIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHZpZXdCb3g9IjAgMCAyNDAuMSAyNDAuMSI+DQo8bGluZWFyR3JhZGllbnQgaWQ9Ik92YWxfMV8iIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iLTgzOC4wNDEiIHkxPSI2NjAuNTgxIiB4Mj0iLTgzOC4wNDEiIHkyPSI2NjAuMzQyNyIgZ3JhZGllbnRUcmFuc2Zvcm09Im1hdHJpeCgxMDAwIDAgMCAtMTAwMCA4MzgxNjEgNjYwNTgxKSI+DQogPHN0b3Agb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojMkFBQkVFIi8+DQogPHN0b3Agb2Zmc2V0PSIxIiBzdHlsZT0ic3RvcC1jb2xvcjojMjI5RUQ5Ii8+DQo8L2xpbmVhckdyYWRpZW50Pg0KPGNpcmNsZSBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0idXJsKCNPdmFsXzFfKSIgY3g9IjEyMC4xIiBjeT0iMTIwLjEiIHI9IjEyMC4xIi8+DQo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZmlsbD0iI0ZGRkZGRiIgZD0iTTU0LjMsMTE4LjhjMzUtMTUuMiw1OC4zLTI1LjMsNzAtMzAuMiBjMzMuMy0xMy45LDQwLjMtMTYuMyw0NC44LTE2LjRjMSwwLDMuMiwwLjIsNC43LDEuNGMxLjIsMSwxLjUsMi4zLDEuNywzLjNzMC40LDMuMSwwLjIsNC43Yy0xLjgsMTktOS42LDY1LjEtMTMuNiw4Ni4zIGMtMS43LDktNSwxMi04LjIsMTIuM2MtNywwLjYtMTIuMy00LjYtMTktOWMtMTAuNi02LjktMTYuNS0xMS4yLTI2LjgtMThjLTExLjktNy44LTQuMi0xMi4xLDIuNi0xOS4xYzEuOC0xLjgsMzIuNS0yOS44LDMzLjEtMzIuMyBjMC4xLTAuMywwLjEtMS41LTAuNi0yLjFjLTAuNy0wLjYtMS43LTAuNC0yLjUtMC4yYy0xLjEsMC4yLTE3LjksMTEuNC01MC42LDMzLjVjLTQuOCwzLjMtOS4xLDQuOS0xMyw0LjggYy00LjMtMC4xLTEyLjUtMi40LTE4LjctNC40Yy03LjUtMi40LTEzLjUtMy43LTEzLTcuOUM0NS43LDEyMy4zLDQ4LjcsMTIxLjEsNTQuMywxMTguOHoiLz4NCjwvc3ZnPg0K";